// removed by extract-text-webpack-plugin
module.exports = {"Wrap":"wWSjZiNI0ajGyKdVSB11z","Tabs":"_2eyFs1rDBGKc28o5OK8Y_-","Active":"_3-VR1SAre_0WxEQtzx5baM","TabIcon":"_3JoSkBFPBvD1k8L0QCqeH7","Content":"R08ck5_oqwlsABov42BgJ"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Utils/VTabBar/styles.module.css
// module id = 602
// module chunks = 0